/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Available_In_LanguageInputs */

const en_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not available in this language`)
};

const th_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีในภาษานี้`)
};

const ja_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この言語では提供されていません`)
};

const fr_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non disponible dans cette langue`)
};

const es_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no disponible en este idioma`)
};

const ru_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`недоступно на этом языке`)
};

const zh_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无此语言版本`)
};

const vi_not_available_in_language = /** @type {(inputs: Not_Available_In_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`không có trong ngôn ngữ này`)
};

/**
* | output |
* | --- |
* | "not available in this language" |
*
* @param {Not_Available_In_LanguageInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const not_available_in_language = /** @type {((inputs?: Not_Available_In_LanguageInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Available_In_LanguageInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_not_available_in_language(inputs)
	if (locale === "ja") return ja_not_available_in_language(inputs)
	if (locale === "fr") return fr_not_available_in_language(inputs)
	if (locale === "es") return es_not_available_in_language(inputs)
	if (locale === "ru") return ru_not_available_in_language(inputs)
	if (locale === "zh") return zh_not_available_in_language(inputs)
	if (locale === "vi") return vi_not_available_in_language(inputs)
	return en_not_available_in_language(inputs)
});